import { EnvironmentUrls } from 'Roblox';
import proxy from '../../libs/proxy';
import { CacheCriteria } from '../../libs/constants';
const { friendsApi } = EnvironmentUrls;

// TODO: replace this provider with auto generated file using Swagger
type DataStoreCallback = (data: object) => void;
type UrlFunction = (userId: number) => string;

const getFriendsRequestUrl = (userId: number) => `${friendsApi}/v1/my/friends/requests`;

const getFriendsApiUrl = (name: string) => {
  return (userId: number) => {
    return `${friendsApi}/v1/users/${userId}/${name}`;
  };
};

const getFriendsUrlConfig = (
  urlFunction: UrlFunction,
  userId: number,
  cursor?: number,
  sortOrder?: string,
  limit?: number
) => {
  const params = {};
  if (cursor) {
    Object.assign(params, { cursor });
  }
  if (sortOrder) {
    Object.assign(params, { sortOrder });
  }
  if (limit) {
    Object.assign(params, { limit });
  }
  return {
    url: urlFunction(userId),
    method: proxy.RequestType.Get,
    retryable: true,
    withCredentials: true,
    params
  };
};

function generateRequestMethod(urlFunction: UrlFunction) {
  return (callback: DataStoreCallback, userId: number, cursor?: number, sortOrder?: string, limit?: number, cacheCriteria?: CacheCriteria) => {
    return proxy.subscribe(callback, getFriendsUrlConfig(urlFunction, userId, cursor, sortOrder, limit), cacheCriteria);
  };
}

function generateRefreshMethod(urlFunction: UrlFunction) {
  return (userId: number, cursor?: number, sortOrder?: string, limit?: number, cacheCriteria?: CacheCriteria) => {
    return proxy.refresh(getFriendsUrlConfig(urlFunction, userId, cursor, sortOrder, limit), cacheCriteria);
  };
}

const FriendsProvider: { [key: string]: any } = {
  getFriends: generateRequestMethod(getFriendsApiUrl('friends')),
  getFollowers: generateRequestMethod(getFriendsApiUrl('followers')),
  getFollowings: generateRequestMethod(getFriendsApiUrl('followings')),
  getFriendsRequests: generateRequestMethod(getFriendsRequestUrl),
  refreshFriends: generateRefreshMethod(getFriendsApiUrl('friends')),
  refreshFollowers: generateRefreshMethod(getFriendsApiUrl('followers')),
  refreshFollowings: generateRefreshMethod(getFriendsApiUrl('followings')),
  refreshFriendsRequests: generateRefreshMethod(getFriendsRequestUrl)
};

export default FriendsProvider;
